import { Filter } from "core/catalog";
import { SwitchInput } from "~/design-system/components/form/SwitchInput";
import { useFilters } from "../../hooks";

export function BooleanFilter({ filter }: { filter: Filter }) {
  const { activeFilters, setFilters } = useFilters();

  return (
    <SwitchInput
      name="boolean-filter"
      label={`${filter.label} (${filter.data.total})`}
      collectUnchecked
      defaultValue={activeFilters[filter.type] === "true"}
      onChange={(isChecked) => {
        setFilters({
          [filter.type]: isChecked ? isChecked : null,
        });
      }}
    />
  );
}
